import React from 'react';

interface ProfileInfoProps {
  label: string;
  value: string;
}

const ProfileInfo: React.FC<ProfileInfoProps> = ({ label, value }) => (
  <div>
    <label className="block text-sm font-medium text-gray-700">{label}</label>
    <div className="mt-1 p-3 bg-gray-50 rounded-md text-gray-900">
      {value}
    </div>
  </div>
);

export default ProfileInfo;